import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthContext } from "../hooks/useAuthContext";
import { UserProvider } from "../context/user";
import { getRelativeLocationUrl } from "~/helpers/navigation";

const RouteAuthorized: React.FC = () => {
  const { user } = useAuthContext();
  const location = useLocation();

  if (!user) {
    const destination = getRelativeLocationUrl(location);
    const redirect =
      destination !== "/" ? `?redirect=${encodeURIComponent(destination)}` : "";

    return <Navigate to={`/login${redirect}`} replace />;
  }

  return (
    <UserProvider user={user}>
      <Outlet />
    </UserProvider>
  );
};

export default RouteAuthorized;
